module.exports = __webpack_public_path__ + "img/箱包4.a21edc89.png";